import React from "react";
import View from "common/View";
import DateTimeList from "./DateTimeList";
import TimeZoneModal from "./TimeZoneModal";
import TimeModal from "./TimeModal";
import DateModal from "./DateModal";

export const DateAndTimeAdmin = () => (
  <View className="container-lg" title="System Date & Time" refresh={null}>
    <DateTimeList />
    <TimeZoneModal />
    <TimeModal />
    <DateModal />
  </View>
);

export default DateAndTimeAdmin;
